import { Card, CardBody, Col, ListGroup, ListGroupItem } from "reactstrap";
import { BorderPrimaryTitle } from "../../../constants";
import { BorderPrimaryData, BorderPrimarySubTitle } from "../../../data/bonusUi/CreativeCard";
import { dynamicImage } from "../../../utils";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { Image } from "../../../coreComponents/Image";

const BorderPrimary = () => {
  return (
    <Col md="6" xl="4">
      <Card>
        <CommonCardHeader title={BorderPrimaryTitle} span={BorderPrimarySubTitle} headClass="border-l-primary border-3 pb-0" />
        <CardBody>
          <ListGroup>
            {BorderPrimaryData.map((item) => (
              <ListGroupItem action className={`${item.id === 1 ? "active" : ""}`} key={item.id}>
                <Image className="rounded-circle" src={dynamicImage(`user/${item.image}`)} alt="user" />
                {item.name}
              </ListGroupItem>
            ))}
          </ListGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BorderPrimary;
